/*
 * @stayai — Upcart cart-drawer "subscription upgrade" plan filter.
 * Logic, reasoning and edit warnings: notes-stores/sprinkle.md.
 */
(function () {
  "use strict";

  var ACTIVE_APP_ID = String(window.STAYAI_ACTIVE_APP_ID || "").trim();
  if (!ACTIVE_APP_ID) return;

  var DEBUG = window.STAYAI_UPCART_DEBUG || false;
  function log() { if (DEBUG) console.log.apply(console, [">>> [upcart-filter]"].concat([].slice.call(arguments))); }

  var DRAWER_HOST_ID = "upCart";
  var SELECT_SEL = ".upcart-subscription-upgrade-dropdown";
  var WRAPPER_SEL = ".upcart-subscription-upgrade-section";
  var ITEM_SEL = ".upcart-product-item"; // id = "<variantId>:<lineKey>"

  var planAppId = Object.create(null);      // plan id -> app_id
  var variantHandle = Object.create(null);  // variant id -> handle
  var productAppIds = Object.create(null);  // handle -> [app_id, ...]
  var productCache = Object.create(null);   // handle -> Promise (fetch once)
  var refreshPromise = null;                // shared in-flight fetch — never a timestamp throttle

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.selling_plan_groups) {
          productAppIds[handle] = p.selling_plan_groups.map(function (g) { return String(g.app_id); });
          p.selling_plan_groups.forEach(function (g) {
            (g.selling_plans || []).forEach(function (sp) { planAppId[String(sp.id)] = String(g.app_id); });
          });
          log("fetched plan map for", handle, "-", p.selling_plan_groups.length, "group(s)");
        } else {
          log("no selling_plan_groups for", handle);
        }
      })
      .catch(function (err) { log("fetch failed for", handle, err); }); // degrade to show-all
    return productCache[handle];
  }

  function refreshMap() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var handles = {};
        cart.items.forEach(function (it) {
          if (!it.handle) return;
          handles[it.handle] = true;
          if (it.variant_id) variantHandle[String(it.variant_id)] = it.handle;
        });
        return Promise.all(Object.keys(handles).map(fetchProduct));
      })
      .catch(function (err) { log("cart fetch failed", err); })
      .then(function (result) { refreshPromise = null; return result; });
    return refreshPromise;
  }

  // Attribute + !important rule, not inline style — see store notes.
  function setControlHidden(el, hide) {
    if (hide === (el.dataset.stayHideUpgrade === "1")) return;
    if (!hide) { delete el.dataset.stayHideUpgrade; log("upgrade control shown"); return; }
    if (!document.getElementById("stayai-upcart-hide-style")) {
      var style = document.createElement("style");
      style.id = "stayai-upcart-hide-style";
      style.textContent = "[data-stay-hide-upgrade]{display:none !important}";
      document.head.appendChild(style);
    }
    el.dataset.stayHideUpgrade = "1";
    log("upgrade control hidden");
  }

  // ===== BEGIN upgrade-control gate — TEMPORARY, REMOVE AT CUTOVER =====
  // Off switch: window.STAYAI_UPCART_HIDE_UPGRADE = false
  // Remove: delete this block + the upgradeGateWantsHide() call in applyGate(). See store notes.
  var HIDE_UPGRADE = window.STAYAI_UPCART_HIDE_UPGRADE !== false;
  function upgradeGateWantsHide(section) {
    if (!HIDE_UPGRADE) return false;
    var item = section.closest(ITEM_SEL);
    var variantId = item && item.id ? item.id.split(":")[0] : null;
    var handle = variantId ? variantHandle[variantId] : null;
    var appIds = handle ? productAppIds[handle] : null;
    if (!appIds || !appIds.length) return true; // unknown -> fail closed
    for (var i = 0; i < appIds.length; i++) if (appIds[i] !== ACTIVE_APP_ID) return true;
    return false;
  }
  // ===== END upgrade-control gate =====

  function applyGate(section) {
    var hide = upgradeGateWantsHide(section);
    if (!hide) {
      var sel = section.querySelector(SELECT_SEL);
      if (sel && sel.options.length && ![].some.call(sel.options, function (o) { return !o.hidden; })) hide = true;
    }
    setControlHidden(section, hide);
  }

  // Cosmetic only. disabled/hidden, never remove(); no synthetic events. See store notes.
  function filterSelect(select) {
    var newlyHidden = 0;

    [].slice.call(select.options).forEach(function (opt) {
      var appId = planAppId[opt.value];
      if (!appId) return;                  // unknown -> leave visible
      if (appId === ACTIVE_APP_ID) return;
      if (!opt.hidden) newlyHidden++;
      opt.disabled = true;
      opt.hidden = true;
    });

    [].slice.call(select.querySelectorAll("optgroup")).forEach(function (og) {
      if (!og.querySelector("option:not([hidden])")) og.hidden = true;
    });

    select.dataset.stayFiltered = "1"; // observability only — not a skip gate

    if (newlyHidden) log("hid", newlyHidden, "foreign option(s)");
  }

  function deepSelects(root, acc) {
    acc = acc || [];
    acc.push.apply(acc, root.querySelectorAll(SELECT_SEL));
    root.querySelectorAll("*").forEach(function (el) { if (el.shadowRoot) deepSelects(el.shadowRoot, acc); });
    return acc;
  }

  function runFilter(root) {
    var selects = deepSelects(root);
    // Sections are scanned separately: a one-time line has a section but no select.
    var sections = [].slice.call(root.querySelectorAll(WRAPPER_SEL));
    if (!selects.length && !sections.length) return;

    // Fetch bounded to one attempt per node; gating/filtering itself always re-runs.
    var needsMap = sections.filter(function (el) {
      if (el.dataset.stayMapTried === "1") return false;
      var item = el.closest(ITEM_SEL);
      var variantId = item && item.id ? item.id.split(":")[0] : null;
      var handle = variantId ? variantHandle[variantId] : null;
      return !handle || !productAppIds[handle];
    }).concat(selects.filter(function (el) {
      return el.dataset.stayMapTried !== "1" &&
        [].some.call(el.options, function (o) { return !(o.value in planAppId); });
    }));

    function apply() {
      sections.forEach(applyGate);
      selects.forEach(filterSelect);
    }

    if (needsMap.length) {
      needsMap.forEach(function (el) { el.dataset.stayMapTried = "1"; });
      refreshMap().then(apply); // never decide against a possibly-empty map
    } else {
      apply();
    }
  }

  var observer = null;

  function attach(host) {
    if (!host) return false;
    var root = host.shadowRoot || host; // light DOM here; shadow on other stores
    if (observer) return true;
    var debounce;
    observer = new MutationObserver(function () {
      if (!host.isConnected) {
        observer.disconnect();
        observer = null;
        log("drawer host removed; observer disconnected");
        return;
      }
      clearTimeout(debounce);
      debounce = setTimeout(function () { runFilter(root); }, 30);
    });
    observer.observe(root, { childList: true, subtree: true });
    runFilter(root);
    log("attached to drawer (" + (root === host ? "light DOM" : "shadow root") + ", ACTIVE_APP_ID=" + ACTIVE_APP_ID + ")");
    return true;
  }

  function tryAttach() {
    return attach(document.getElementById(DRAWER_HOST_ID));
  }

  // The drawer host mounts lazily — watch for it rather than polling on a timer.
  function init() {
    if (tryAttach()) return;
    var bodyObserver = new MutationObserver(function () {
      if (tryAttach()) {
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    log("drawer host not yet present; watching for it");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
